module.exports = __webpack_public_path__ + "img/logo.ec5aa7dc.png";